import { createStore } from 'vuex'

export default createStore({
  state: {
    sidebarVisible: true,
    sidebarUnfoldable: false,
    darkMode: false
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },
    toggleDarkMode(state) {
      state.darkMode = !state.darkMode
    },
    setDarkMode(state) {
      state.darkMode = true
    }
  },
  actions: {},
  modules: {},
})
